exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".uploadBtn_camp{display:inline-block;width:130px;text-align:center;text-indent:0}.el-upload__files{display:none}.classItem{display:inline-block;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-63cc24f6!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/departmentManage.vue
// module id = 556
// module chunks = 0